<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Review } from '../../_shared/types/review.types';
import { formatDateToSince } from '../../_shared/hooks/useDateHelper';
import { abbreviateText } from '../../_shared/hooks/useTextHelper';

export default defineComponent({
  name: 'ReviewList',
  props: {
    list: { type: Array as PropType<Array<Review>> },
  },
  methods: {
    abbreviateText,
    formatDateToSince,
  },
});
</script>

<template>
  <div v-if="list" class="review-list-wrapper">
    <div v-for="review in list" :key="review._id" class="review-wrapper">
      <div class="review-head">
        <div class="img-circle">{{ abbreviateText(review.authorName, 2) }}</div>
        {{ review.authorName }}
      </div>

      <div class="review-body">
        <div class="rating">
          <div class="stars">
            <template v-for="value in Array.from(Array(5))" :key="value">
              {{ value }}
              <i class="fa fa-star"></i>
            </template>
          </div>
          <span class="published-at">
            vor {{ formatDateToSince(review.publishedAt) }}
          </span>
        </div>
        <div class="text">{{ review.text }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.review-list-wrapper {
}

.review-head {
  align-items: center;
  display: flex;
  gap: 8px;
  font-variant: unicase;
  padding: 0 0 12px;
}

.img-circle {
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: var(--background-color-content-light);
  height: 36px;
  width: 36px;
}

.rating {
  display: flex;
  gap: 8px;
}

.fa-star {
  color: var(--color-cta-border);
}

.published-at {
  color: var(--color-gray-6);
}

.text {
  margin-top: 4px;
}

.review-wrapper {
  border: 1px solid var(--border-color-content);
  border-width: 1px 0;
  color: var(--text-color-dark);
  margin-top: -1px;
  padding: 24px;
  text-align: left;
}
</style>
